//TODO: Create a custom hook for fetching lists
import { useQuery } from "@tanstack/react-query";
import { queryCommonFlags } from "@/api/constants";
import {
  getLocations,
  getPropertyTypesV2,
} from "@/modules/common/api/index.v2";
import { useMemo, useState } from "react";
import { debounce } from "lodash";
import { LocationDataParams } from "../types";

interface LocationSearchParams {
  currentPage?: string;
  locationDataParams?: LocationDataParams;
  areaUId?: string;
  isLaunch?: boolean;
  includeChildLocations?: boolean;
  isExpo?: boolean;
  locationDeveloperUId?: string;
  compoundFilterBydeveloperUId?: string;
}

const useLocationsData = ({
  currentPage,
  locationDataParams,
  areaUId,
  isLaunch,
  includeChildLocations,
  isExpo,
  locationDeveloperUId,
  compoundFilterBydeveloperUId,
}: LocationSearchParams = {}) => {
  const [locationSearchTerm, setLocationsSearchTerm] = useState<string>("");
  const storedOrgName = localStorage.getItem("selectedOrganizationName");
  const homeLocalStorageFilters = localStorage.getItem(
    `leadSearchFilters${storedOrgName}`
  );

  const parsedFilters = homeLocalStorageFilters
    ? JSON.parse(homeLocalStorageFilters)
    : {};

  const listingDashboardPendingFilters = localStorage.getItem(
    `ListingsTableFiltersPending${storedOrgName}`
  );
  const parsedListingDashboardPendingFilters = listingDashboardPendingFilters
    ? JSON.parse(listingDashboardPendingFilters)
    : {};

  const nextActionsLocalStorageFilters = localStorage.getItem(
    `nextActionsSearchFilters${storedOrgName}`
  );

  const parsedFiltersNextActions = nextActionsLocalStorageFilters
    ? JSON.parse(nextActionsLocalStorageFilters)
    : {};

  const path = window.location.pathname;

  const params = {
    page: 1,
    pageSize: 50,
    ...(locationSearchTerm.trim() && { name: locationSearchTerm }),
    ...(currentPage === "Home" &&
      parsedFilters?.locationUIds && {
        savedUIds: parsedFilters?.locationUIds,
      }),
    ...(currentPage === "Home" &&
      parsedFiltersNextActions?.locationUIds &&
      path.includes("next-actions") && {
        savedUIds: parsedFiltersNextActions?.locationUIds,
      }),
    ...(includeChildLocations && { includeChildLocations:includeChildLocations }),
    ...(currentPage === "ListingDashboard" && {
      ...(locationDataParams === LocationDataParams.AREA &&
        parsedListingDashboardPendingFilters?.areaUIds && {
          savedUIds: parsedListingDashboardPendingFilters.areaUIds,
        }),
      ...(locationDataParams === LocationDataParams.COMPOUND &&
        parsedListingDashboardPendingFilters?.compoundUIds && {
          savedUIds: parsedListingDashboardPendingFilters.compoundUIds,
        }),
    }),

    ...(locationDataParams && { locationTypes: locationDataParams }),
    ...(areaUId && { areaUId }),
    ...(typeof isLaunch === "boolean" && { isLaunch }),
    ...(typeof isExpo === "boolean" && { isExpo }),
    ...(locationDeveloperUId && { locationDeveloperUId }),
    ...(compoundFilterBydeveloperUId && { compoundFilterBydeveloperUId   }),
  };

  const handleSearchChange = useMemo(
    () =>
      debounce((event) => {
        let searchTerm = "";
        if (typeof event === "string") {
          searchTerm = event;
        } else {
          searchTerm = event?.target?.value || "";
        }
        setLocationsSearchTerm(searchTerm);
      }, 300),
    []
  );

  const {
    data: locationsData,
    error: locationsError,
    isLoading: locationsLoading,
  } = useQuery({
    queryKey: ["getLocations", params, locationSearchTerm],
    queryFn: async () => {
      const response = await getLocations(params);
      return response?.data || [];
    },
    ...queryCommonFlags,
    staleTime: Infinity,
  });

  //TODO: add PropertyTypes to a different hook
  const { data: PropertyTypeData, isLoading: propertyTypeLoading } = useQuery({
    queryKey: ["getPrpoertyTypes"],
    queryFn: async () => {
      const response = await getPropertyTypesV2();
      return response?.data || [];
    },
    ...queryCommonFlags,
    staleTime: Infinity,
  });

  return {
    locationsData,
    locationsError,
    locationsLoading,
    locationSearchTerm,
    handleSearchChange,
    setLocationsSearchTerm,
    PropertyTypeData,
    propertyTypeLoading,
  };
};
export default useLocationsData;
